// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"0e364ecb","42":"be53ddfd","97":"23156f06","294":"4f7a7ac4","475":"13d3039f","546":"8a5560ff","625":"e0b984ab","787":"7c9c6488"}[chunkId] + ".chunk.js";
};